var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.182,
    height: 20.005,
    viewBox: "0 0 21.182 20.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reddit",
    transform: "translate(-237.351 -999.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-reddit-alien",
    "data-name": "Icon awesome-reddit-alien",
    d: "M20.138,9.9a2.377,2.377,0,0,0-1.692.71,11.474,11.474,0,0,0-6.121-1.888l1.237-5.572,3.938.884a1.753,1.753,0,0,0,1.75,1.75,1.772,1.772,0,1,0-1.576-2.563l-4.348-.964a.416.416,0,0,0-.491.317L11.477,8.721a11.617,11.617,0,0,0-6.085,1.911,2.354,2.354,0,1,0-2.737,3.741,5,5,0,0,0-.116,1.1c0,3.741,4.214,6.773,9.389,6.773,5.2,0,9.411-3.031,9.411-6.773a4.259,4.259,0,0,0-.138-1.121A2.35,2.35,0,0,0,20.138,9.9ZM6.258,14.609a1.761,1.761,0,1,1,1.772,1.75,1.765,1.765,0,0,1-1.772-1.75Zm9.567,4.174c-1.625,1.625-6.21,1.625-7.835,0a.416.416,0,0,1,0-.612.429.429,0,0,1,.589,0c1.241,1.272,5.357,1.295,6.652,0a.429.429,0,0,1,.589,0A.413.413,0,0,1,15.826,18.784Zm-.036-2.42a1.761,1.761,0,1,1,1.772-1.75A1.753,1.753,0,0,1,15.79,16.364Z",
    transform: "translate(236.032 997.756)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.a7034cff70e683411cc1b5c6b8762bc4.svg";
export { ForwardRef as ReactComponent };